// note these should be UPPERCASE, as they are now already used everywhere decided not to update
export const localStorageFav = 'clicFavourites';
export const localStorageList = 'clicAddToList';
export const localStorageLang = 'clicLang';
export const localStorageSideNav = 'clicSideNav';
export const localStorageAuthToken = 'clicAuthToken';
export const localStorageAuthTokenExpiry = 'clicAuthTokenExpiry';
export const localStorageDevice = 'clicDeviceId';
export const localStorageIsChild = 'clicIsChild';
export const localStorageProfileName = 'clicProfileName';
export const localStorageProfileId = 'clicProfileId';
export const localStorageSubtitleId = 'clicSubtitleId';
export const localStorageSignedPref = 'clicSignedPreference';
export const localStorageFetchDelay = 'clicFetchDelay';
export const localStorageTheme = 'clicTheme';
export const LS_AUTO_NEXT = 'clicIsAutoNext';
export const LS_EMAIL = 'clicEmail';
export const LS_PC = 'clicPC';

export const PLATFORM = 'web';
export const DEFAULT_IMAGE = 'default.jpg';
export const VIDIO_ID_PREPEND = 'promo_video_';
export const NOWNEXT_RELOAD_TIME = 60000;
export const META_DEFAULT_IMAGE = 'clic.jpg';
export const META_DESCRIPTION_MAX_CHAR = 160;
export const APP_VERSION = '2.1.10';
export const COMPETITION_DATE = '08/10/2019'; //mm/dd/yyyy
export const DEFAULT_THEME = 'dark';
export const CAT_ROW_LIMIT = 12;
export const GDPR_COOKIE = 'euconsent';

export const OE_LIVE_WINDOW_HOURS = 24;
export const OE_CATCHUP_WINDOW_HOURS = 72;

/* Socket URL */
export const SOCKET_URL_STAGING =
  'https://sckt-stage.s4c.cymru/mys4c/broadcastToUserSocket';
export const SOCKET_URL = 'https://sckt.s4c.cymru/mys4c/broadcastToUserSocket';
export const SOCKET_URL_STAGING_V2 =
  'https://clic.stage.api.s4c.cymru/mys4c/broadcastToUserSocket';
export const SOCKET_URL_V2 =
  'https://clic.api.s4c.cymru/mys4c/broadcastToUserSocket';

/* Cysill Search */
export const CYSILL_URL = 'https://api.techiaith.org/cysill/v1/';
export const CYSILL_ACCESS_KEY = 'c05b1387-e364-4d24-b1d1-580562017eb3';
export const CYSILL_MAX_ERRORS = 1;
export const MAX_NUM_CYSILL_RESULTS = 10;

/* Email Verification */
export const VERIFICATION_URL = 'https://apilayer.net/api/check';
export const VERIFICATION_ACCESS_KEY = '63e71c7b55de609b8876f0ab8412b4bd';
export const VERIFICATION_THRESHOLD = 0.32;

/* haveibeenpwned */
export const PWNED_PASSWORDS_URL = 'https://api.pwnedpasswords.com/range/';

/* API Root for the Feeds */
export const API_ROOT_LOCAL = '/json/';
export const API_ROOT_LIVE = 'https://www.s4c.cymru/df/';
export const API_ROOT_TEST = 'https://test.s4c.cymru/df/';
export const API_ROOT_BETA = 'https://beta.s4c.cymru/df/';
export const API_ROOT_TEST3 = 'https://test3.s4c.cymru/df/';
export const API_ROOT_LIVE_CMS = 'https://www.s4c.cymru/api/0_0_1/';
export const API_ROOT_LIVE_TEST3 = 'https://test3.s4c.cymru/df/';
export const SEARCH_REQUEST_URL = API_ROOT_LIVE_TEST3 + 'search';
export const CDN_ROOT_LIVE = 'https://s4c-cdn.co.uk/';
export const API_ROOT_PROTOCOL = 'https://';
export const API_ROOT_HOST = '.s4c.cymru/df/';
export const MYS4C_ROOT_PROTOCOL = 'https://';
export const MYS4C_ROOT_HOST = '.s4c.cymru/capi';
export const MYS4C_ROOT_LOCAL = 'https://test3.s4c.cymru/capi';
export const API_ROOT_LIVE_CMS_V2 = 'https://cms.v3.s4c.cymru/api/v2/clic/';
export const API_ROOT_STAGE_CMS_V2 = 'https://stage.v3.s4c.cymru/api/v2/clic/';
export const API_ROOT_IMG_LIVE_CMS_V2 = 'https://images.cms.v3.s4c.cymru';
export const API_ROOT_IMG_STAGE_CMS_V2 = 'https://images.stage.v3.s4c.cymru';
export const MYS4C_PERSONALIZE_ROOT_HOST_STAGE =
  'https://stage.recommendations.s4c-cdn.co.uk';
export const MYS4C_PERSONALIZE_ROOT_HOST_LIVE =
  'https://recommendations.s4c-cdn.co.uk';
//Data Feeds root urls
export const DATA_FEEDS_ROOT_LOCAL = '/json/';
export const DATA_FEEDS_ROOT_TEST3 =
  'https://test3.s4c.cymru/clic/s4cplayer/data_feeds/';
export const DATA_FEEDS_ROOT_BETA =
  'https://beta.s4c.cymru/clic/s4cplayer/data_feeds/';
export const DATA_FEEDS_ROOT_LIVE =
  'https://www.s4c.cymru/clic/s4cplayer/data_feeds/';
export const DATA_FEEDS_PROTOCOL = 'https://';
export const DATA_FEEDS_HOST = '.s4c.cymru/clic/s4cplayer/data_feeds/';

//Feed Data Sources
export const FEED_URLSRC_DF = 0;
export const FEED_URLSRC_DATA = 1;
export const FEED_URLSRC_CMS = 2;
export const FEED_URLSRC_CAPI = 3;
export const FEED_URLSRC_EMAIL_VERIFY = 4;
export const FEED_URLSRC_CYSILL = 5;
export const FEED_URLSRC_CMS_V2 = 6;
export const FEED_URLSRC_PASS_BREACH = 7;
export const FEED_URLSRC_FBT = 8;

// LANG
export const EN_FORM_VALUE = 'en';
export const CY_FORM_VALUE = 'cy';
export const EN_STATE_VALUE = 1;
export const CY_STATE_VALUE = 0;

// URLs
export const BASE_URL = 'https://www.s4c.cymru/';
export const SEARCH_IMG_THUMBNAIL_URL = BASE_URL + 'amg/landscape/300x169/';
export const SEARCH_RELATIVE_URL = '/search?s=';
export const DEFAULT_IMG_LAND_1280 =
  BASE_URL + 'amg/landscape/1280x720/' + DEFAULT_IMAGE;
export const AWS_SMART_FILTER_BASE = 'https://www.s4c.cymru/amg/';
export const PROD_URL = 'https://www.s4c.cymru/clic/';
export const PROM_DEFAULT_IMAGE = `${BASE_URL}/amg/landscape/1280x720/${DEFAULT_IMAGE}`;
export const DEEP_LINK_URL = 'https://4zhkc.app.link/clic-app';
export const EXTRA_FEED_POSTER_URL = BASE_URL + 'amg/1920x1080/';

// FORM GENDER VALUES
export const NONE_FORM_VALUE = '0';
export const MALE_FORM_VALUE = 'M';
export const FEMALE_FORM_VALUE = 'F';
export const OTHER_FORM_VALUE = 'O';
export const PREFER_NOT_FORM_VALUE = 'P';

//These are section ids in the CMS
export const PROM_HOME_ID = 218;
export const PROM_CAT_ID = 220;
export const PROM_CAT_DRAMA_ID = 219;
export const PROM_CAT_SPORT_ID = 221;
export const PROM_CAT_ENTS_ID = 222;
export const PROM_CAT_CYW_ID = 223;
export const PROM_CAT_STWNSH_ID = 224;
export const PROM_CAT_FACT_ID = 227;
export const PROM_CAT_MUSIC_ID = 228;
export const PROM_CAT_NEWS_ID = 229;
export const PROM_CAT_RELIGION_ID = 225;
export const PROM_CAT_RURAL_ID = 226;
export const PROM_CAT_SIGNED_ID = 231;
export const PROM_CAT_WW_ID = 230;
export const PROM_CAT_HANSH_ID = 247;
export const PROM_CAT_LEARNERS_ID = 251;
export const PROM_CAT_WALTER_ID = 252;
export const PROM_CAT_HERE_ID = 261;
export const CATCH_UP_MORNING_TIME = 4;
export const CATCH_UP_AFTERNOON_TIME = 12;
export const CATCHUP_EVENING_TIME = 18;
export const CATCHUP_NIGHT_TIME = 20;

export const AD_BLOCK_DIALOG = 'adblock';
export const PLAYER_ERROR_DIALOG = 'playererror';
export const ACTION_DIALOG = 'action';
export const ACTION_FAIL_DIALOG = 'action_fail';
export const CONFIRM_DIALOG = 'confirm';
export const CONFIRM_SIGN_OUT_DIALOG = 'confirm_sign_out';
export const CONFIRM_SIGN_OUT_ALL_DIALOG = 'confirm_sign_out_all';
export const DELETE_ACC_DIALOG = 'deleteAcc';
export const DELETE_PROF_DIALOG = 'deleteProf';
export const ACTION_CHANGE_PWORD_DIALOG = 'action_change_pword';
export const VERIFY_AGE_DIALOG = 'verifyAge';
export const ENTER_PIN_DIALOG = 'enterPin';
export const SHARE_DIALOG = 'share';
export const SHORTCUT_DIALOG = 'shortcut';

export const PATH_CHANGE_THEME = '/MyS4C/Account/ChangeTheme';
export const PATH_CHANGE_EMAIL = '/MyS4C/Account/ChangeEmail';
export const PATH_DELETE_ACCOUNT = '/MyS4C/Account/DeleteAccount';
export const PATH_CHANGE_PASSWORD = '/MyS4C/Account/changePassword';
export const PATH_EDIT = '/MyS4C/Account/Edit';
export const PATH_COMMS = '/MyS4C/Account/Comms';
export const PATH_WATCHING = '/MyS4C/Watching';
export const PATH_MY_LIST = '/MyS4C/MyList';
export const PATH_ACCOUNT = '/MyS4C/Account';
export const PATH_PARENT = '/MyS4C/Account/ParentalControl';
export const PATH_PARENT_FORGOT_PIN = '/MyS4C/ForgottenPIN';
export const PATH_FORGOT = '/MyS4C/ForgotPassword';
export const PATH_FORGOT_UPDATE = '/MyS4C/ForgotPasswordUpdate';
export const PATH_SIGN_IN = '/MyS4C/SignIn';
export const PATH_SIGN_UP = '/MyS4C/SignUp';
export const PATH_LIVE = '/Live';
export const PATH_PC = '/MyS4C/ParentalControl';
export const PATH_PROFILES = '/MyS4C/Profiles';
export const PATH_PROFILE_EDIT = '/MyS4C/ProfileEdit';
export const PATH_PROFILE_ADD = '/MyS4C/ProfileEdit/add';
export const PATH_AUTHENTICATED_REDIRECT = '/';
export const PATH_AUTHENTICATED_REDIRECT_SELECT_PROFILE =
  '/MyS4C/SignUp/Profiles';
export const PATH_BASE = window.CLIC_BASENAME;
export const PATH_DELETE_SUCCESS = '/MyS4C/DeleteSuccess';

export const ML_LIST_1 = 'ml_mailing_list_1';
export const ML_LIST_2 = 'ml_mailing_list_2';

export const PLAYER_LIVE = 'live';
export const PLAYER_EXC = 'exclusive';
export const PLAYER_OD = 'od';
export const PLAYER_CYWTIWB = 'cywtiwb';
export const PLAYER_CYWTIWB_POSTER_DEFAULT =
  'https://www.s4c.cymru/amg/1920x1080/cyw-tiwb.jpg';
export const PLAYER_SSAI = true;

export const DEFAULT_LIVE_STREAM = 'streams/live_cy';
export const DEFAULT_CYWTIWB_STREAM = 'cyw/cywtv1';
export const PLAYER_STATE_INACTIVE = 'inactive';
export const PLAYER_STATE_ACTIVE = 'active';
export const PLAYER_STATE_LOADING = 'loading';
export const PLAYER_STATE_END_MORE = 'end-more';
export const PLAYER_STATE_END = 'end';
export const PLAYER_EVENTS_LOADED = 'clicPlayerLoaded';
export const PLAYER_ERROR_EVENT = 'clicPlayerError';
export const PLAYER_EVENTS_ENDED = 'clicPlayEnded';
export const PLAYER_EVENTS_PLAYING = 'playing';
export const PLAYER_EVENTS_PROG_CHANGE = 'playerProgrammeChange';
export const PLAYER_EVENTS_SCHED_CHANGE = 'scheduleChange';

export const PLAYER_CONFIG_NO_LOAD = 0;
export const PLAYER_CONFIG_LOAD_PLAY = 1;
export const PLAYER_CONFIG_LOAD_ONLY = 2;

export const PLAY_NEXT_DELAY_MS = 15000;

// Parent control states
export const PC_STATE_NONE = 0;
export const PC_STATE_OFF = 'N';
export const PC_STATE_ON = 'Y';
export const PIN_SIZE = 4;
export const PIN_ID = 'pin_digit_';
export const PIN_YOUR_ID = 'pin_your_digit_';
export const PIN_CONFIRM_ID = 'confirm_pin_digit_';

export const PAGE_TITLE = 'S4C Clic';
export const PAGE_TITLE_SEPARATOR = '|';

// channel IDs
export const CYW_ID = 13; // category ID for cyw
export const BOXSET_ID = 24; // category ID for box sets
export const STWNSH_ID = 16; // category ID for Stwnsh
export const HANSH_ID = 25; // category ID for Hansh
export const LEARNERS_ID = 26; // category ID for Learners
export const WALTER_ID = 27; // category ID for Walter Presents
export const HERE_ID = 28; // category ID for Here for you

export const EMAIL_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // eslint-disable-line
export const DOB_REGEX_ISO = /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/;
export const DOB_REGEX_UK = /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/;
export const POST_CODE_REGEX = /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/i;

export const MYS4C_MAIN_PROF_NAME = 'main_profile_name';
export const MYS4C_MAIN_PROF_ID = 'main_profile_id';
export const MYS4C_PROF_NAME = 'profile_name';

export const MAIL_LIST_ON_SIGNUP = 'mail_24228';
export const MAIL_LIST_ON_SIGNUP_ID = 24228;

export const CMS_PROGROW_TYPE_CATEGORY = 'category';
export const CMS_PROGROW_TYPE_BOXSET = 'boxSet';
export const CMS_PROGROW_TYPE_PROGRAMMESET = 'programmeSet';

export const MYS4C_ERROR_UNAUTH = [
  '00019',
  '00014',
  '00018',
  '00015',
  '00013',
  '00008',
  '00001',
  '00017',
];
export const MYS4C_ERROR_IGNORE = [
  '00000',
  '00001',
  '00019',
  '00014',
  '00018',
  '00015',
  '00013',
  '00008',
  '00017',
  '00007',
  '00031',
  '00033',
];
export const MYS4C_UNAUTH_CALLS = [
  'login',
  'create_clic_user',
  'reset_pw_email_address',
  'verify_account',
  'save_new_password',
];
export const DEFAULT_PROFILE_IMG = 'panda.png';
export const MORE_LIKE_NUM_RESULTS = 14;

export const REDUCER_IS_LOADING_PREFIX = 'is_loading_';
export const REDUCER_HAS_ERRORED_PREFIX = 'has_errored_';
export const REDUCER_SUCCESS_PREFIX = 'success_';
export const REDUCER_RESET_PREFIX = 'reset_';
export const REDUCER_NOW_NEXT = 'now_next';
export const REDUCER_PROG = 'prog';
export const REDUCER_CATCHUP_DAYS = 'catchup_days';
export const REDUCER_SEARCH_RESULTS = 'search_results';
export const REDUCER_SEARCH_KEYWORD = 'search_keyword';
export const REDUCER_AZ_LETTERS = 'az_letters';
export const REDUCER_AZ_PROGRAMMES = 'az_programmes';
export const REDUCER_CATEGORIES = 'categories';
export const REDUCER_CATEGORIES_HOME = 'categories_home';
export const REDUCER_CATEGORIES_DATA = 'categories_data';
export const REDUCER_EXTRA_FEED_HOME = 'extra_feed_home';
export const REDUCER_EXTRA_FEED_DAY = 'extra_feed_day';
export const REDUCER_EXTRA_FEED = 'extra_feed';
export const REDUCER_PROMO = 'promo';
export const REDUCER_CATCHUP_DAY = 'catchup_day';
export const REDUCER_CATCHUP_FEATURE = 'catchup_feature';
export const REDUCER_IMG_OVERRIDE = 'img_override';
export const REDUCER_PODCASTS = 'podcasts';
export const REDUCER_WATCHING = 'watching';
export const REDUCER_MY_LIST = 'my_list';
export const REDUCER_CHECK_EMAIL = 'check_email';
export const REDUCER_BROADCAST_SMART_PIN = 'broadcast_pin';
export const REDUCER_PROCESS_SMART_PIN = 'process_pin';
export const REDUCER_CYSILL_SEARCH = 'cysill';
export const REDUCER_SEARCH_MAPPING = 'search_mapping';
export const EXTRA_FEED_SEPARATOR = '-';
export const PASSWORD_MAX_CHARACTERS = 128;
export const PASSWORD_MIN_CHARACTERS = 6;
export const PASSORD_STRENGTH_MIN = 2;
export const AUTO_PLAY_TYPE_NEXT = 'next';
export const REDUCER_PROFILES = 'profiles';
export const SIGNED_URL_STRING = 'signed';
export const REDUCER_CATEGORY_CONTENT = 'search_category_content';
export const SEARCH_CAT_MIN_CHARACTERS = 3;
export const SUBTITLE_ID_NONE = 0;
export const SUBTITLE_ID_CY = 1;
export const SUBTITLE_ID_EN = 2;
export const FETCH_DELAY_MIN = 60;
export const REDUCER_TECH_MESSAGE = 'tech_messsage';
export const REDUCER_CHANNELS = 'channels';
export const REDUCER_BOXSETS = 'boxsets';
export const REDUCER_HOME = 'home';
export const REDUCER_PROG_AVAIL = 'prog_avial';
export const REDUCER_COMBINED_PROG_LOAD = 'combined_prog_load';
export const REDUCER_CAT_PROGRAMME_ROWS_DATA = 'category_programme_rows';
export const REDUCER_AVATARS = 'avatars';
export const REDUCER_POPULAR = 'popular';
export const REDUCER_TRENDING = 'trending';
export const REDUCER_TOP_PICKS = 'top_picks';
export const REDUCER_MORE_LIKE = 'more_like';
export const REDUCER_PASS_STRENGTH = 'pass_strength';
export const REDUCER_PASS_BREACH = 'pass_breach';
export const REDUCER_FBT = 'fbt';
